import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AlgoliaSearchParams } from "../../../../api/postCall/algoliaSearch";
import { FilterValues } from "../../../../data-model/filterValues";
import { RootState } from "../../../../redux/store/store";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import { generateFilterPayloadForMyPaOrders } from "../utils/generateFilterPayloadForMyPaOrders";

export const useFilterPayload = (
  validFilters: FilterValues[],
  searchTerm: string,
  initialDataFetchingExecuted: boolean,
) => {
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );
  const orgId = getOrgIdForFetchExternalWorklist();

  const [filterPayload, setFilterPayload] =
    useState<AlgoliaSearchParams | null>(null);

  const hasInitialFetchCompleted = useRef(false);

  // Track when initial fetch completes
  useEffect(() => {
    if (initialDataFetchingExecuted && !hasInitialFetchCompleted.current) {
      hasInitialFetchCompleted.current = true;
    }
  }, [initialDataFetchingExecuted]);

  // Update filter payload only after initial fetch is complete
  useEffect(() => {
    if (!hasInitialFetchCompleted.current) {
      return;
    }

    const payload = generateFilterPayloadForMyPaOrders(
      validFilters,
      searchTerm,
      orgId,
      user?.id ?? "",
    );
    setFilterPayload(payload);
  }, [validFilters, searchTerm, orgId, user?.id]);

  return { filterPayload, setFilterPayload };
};
